import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  GetPlanVarDetails,
  AddPlanVar,
  DeletePlanVar,
  UpdatePlan,
} from "../../../../api/User/ACG/PlanVarApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import { GetCBSA } from "../../../../api/User/ACG/CBSAApi";
import { GetIndrDetails } from "../../../../api/User/ACG/IndrApi";
import CustomInputField from "../../../../components/common/CustomInputField";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  cmsa: Yup.string().notOneOf(["Select CBSA"], "Please select CBSA ").required("Please select CBSA"),
  industry: Yup.string()
    .notOneOf(["Select Industry"], "Please select Industry")
    .required("Please select Industry"),
  hmo: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter hmo"),
  ppo: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter ppo"),
  epo: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter epo"),
  hra: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter hra"),
  hsa: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter hsa"),
  kaiser: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter kaiser"),
});

const PlanVar = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [cbsaData, setCbsaData] = useState([]);
  const [industryData, setIndustryData] = useState([]);
  const buttonRef = useRef(null);
  const column = [
    {
      title: "CBSA",
      field: "cmsa",
    },
    {
      title: "Industry",
      field: "industry",
    },
    {
      title: "HMO",
      field: "hmo",
    },
    {
      title: "PPO",
      field: "ppo",
    },
    {
      title: "EPO",
      field: "epo",
    },
    {
      title: "HRA",
      field: "hra",
    },
    {
      title: "HSA",
      field: "hsa",
    },
    {
      title: "KAISER",
      field: "kaiser",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getGeogDetailsData();
      GetCBSA().then((res) => {
        if (res.status === 200 || res.status === 204) {
          setCbsaData(res.data);
        }
      });
      GetIndrDetails().then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIndustryData(res.data);
        }
      });
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getGeogDetailsData();
    GetCBSA().then((res) => setCbsaData(res.data));
    GetIndrDetails().then((res) => setIndustryData(res.data));
  }, []);

  const getGeogDetailsData = () => {
    setIsLoading(true);
    GetPlanVarDetails()
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;
    const { cmsa, industry, hmo, ppo, epo, hra, hsa, kaiser } = values;
    const payload = {
      id: 0,
      cmsa,
      industry,
      cmsA_Industry: cmsa + industry,
      hmo: +hmo,
      ppo: +ppo,
      epo: +epo,
      hra: +hra,
      hsa: +hsa,
      kaiser: +kaiser,
    };

    if (witchAction === "add") {
      AddPlanVar(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdatePlan({
        ...payload,
        id: selectedRowData.id,
        cmsA_Industry: selectedRowData.cmsA_Industry,
      }).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("update");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            PlanVar By Industry & CBSA
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeletePlanVar(selectedRowData?.id).then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                cmsa: selectedRowData?.cmsa ?? "Select CBSA",
                industry: selectedRowData?.industry ?? "Select Industry",
                hmo: selectedRowData?.hmo ?? 0,
                ppo: selectedRowData?.ppo ?? 0,
                epo: selectedRowData?.epo ?? 0,
                hra: selectedRowData?.hra ?? 0,
                hsa: selectedRowData?.hsa ?? 0,
                kaiser: selectedRowData?.kaiser ?? 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              CBSA
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="rounded-0"
                              style={Fontstyling.label}
                              name="cmsa"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                values.cmsa === "Select CBSA" && touched.cmsa
                              }
                            >
                              <option value={"Select CBSA"}>Select CBSA</option>
                              {cbsaData.map(({ CMSA: item }) => (
                                <option
                                  value={item}
                                  selected={values.cmsa === item}
                                >
                                  {item}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.cmsa}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              Industry
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="rounded-0"
                              style={Fontstyling.label}
                              name="industry"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                values.industry === "Select Industry" &&
                                touched.industry
                              }
                            >
                              <option value={"Select Industry"}>
                                Select Industry
                              </option>
                              {industryData.map(({ industry: item }) => (
                                <option
                                  value={item}
                                  selected={values.industry === item}
                                >
                                  {item}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.industry}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="HMO"
                            name="hmo"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="PPO"
                            name="ppo"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="EPO"
                            name="epo"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="HRA"
                            name="hra"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="HSA"
                            name="hsa"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="KAISER"
                            name="kaiser"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add PlanVar By Industry & CBSA
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default PlanVar;
